import { getAroundFacilityRatings } from '../_service'
import { FormatDistance } from '@/views/building/_around_facilities/distance'

export default {
    data() {
        return {
            price_compares: {},
            building_info: [],
            purchase_qualification: [],
            items: [],
        }
    },
    methods: {
        async getData (building_id) {
            const { items, price_compares, basic_informations, purchase_qualification } = await getAroundFacilityRatings(building_id)
            this.price_compares = price_compares
            this.building_info = basic_informations
            if (purchase_qualification && purchase_qualification.length) {
                this.purchase_qualification = purchase_qualification.map(item => {
                    return {
                        title: item.title,
                        desc: item.desc.replace(/\\n/g, "\n")
                    }
                })
            }
            console.log( await getAroundFacilityRatings(building_id));
            this.items = items?.map(item => {
                const { details, category } = item
                if (category !== 'plate') {
                    const details_keys = details ? Object.keys(details) : []
                    if (details_keys.length) {
                        details_keys.forEach(key => {
                            const { radius, nearest } = details[key]
                            details[key].radius = this.formatDistance(radius)
                            if (nearest) {
                                const { distance } = nearest
                                nearest.distance = this.formatDistance(distance)
                            }
                        })
                    }
                }
                return item
            })
        },
        formatDistance(distance) {
            return distance ? FormatDistance(distance) : ''
        }
    }
}